import { CSSProperties } from 'react'

const styles: {
  container: CSSProperties
  instanceRow: CSSProperties
  menuRow: CSSProperties
  instanceControlContainer: CSSProperties
  instanceControlHeader: CSSProperties
  sectionLabel: CSSProperties
  fullWidth: CSSProperties
  activeLabel: CSSProperties
  channelListHeader: CSSProperties
  channelSearchInput: CSSProperties
  filterButton: CSSProperties
  filterLabel: CSSProperties
  filterLabelActive: CSSProperties
  seekBarContainer: CSSProperties
  seekBarTimeRow: CSSProperties
  seekBarTimeLabel: CSSProperties
  logoutButton: CSSProperties
  logoutButtonLabel: CSSProperties
} = {
  container: {
    position: 'fixed',
    right: -400,
    flexDirection: 'column',
    width: 400,
    backgroundColor: '#4d4d4d',
    alignItems: 'center',
    zIndex: 1,
    overflowY: 'scroll',
    display: 'flex',
  },
  instanceRow: {
    width: '100%',
  },
  menuRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    width: '100%',
  },
  instanceControlContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    alignItems: 'stretch',
    color: 'white',
  },
  instanceControlHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 12px 6px',
  },
  sectionLabel: {
    fontSize: 12,
    letterSpacing: 0.5,
    color: '#aaaaaa',
  },
  fullWidth: {
    width: '100%',
  },
  activeLabel: {
    color: 'red',
  },
  channelListHeader: {
    display: 'flex',
    alignItems: 'stretch',
  },
  channelSearchInput: {
    width: 'auto',
    flex: 1,
  },
  filterButton: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 14px',
    backgroundColor: '#5b5b5b',
  },
  filterLabel: {
    color: '#aaaaaa',
    fontSize: 14,
    whiteSpace: 'nowrap',
  },
  filterLabelActive: {
    color: 'red',
    fontSize: 14,
    whiteSpace: 'nowrap',
  },
  seekBarContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    padding: '2px 12px 10px',
  },
  seekBarTimeRow: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  seekBarTimeLabel: {
    fontSize: 11,
    color: '#aaaaaa',
    fontVariantNumeric: 'tabular-nums',
  },
  logoutButton: {
    display: 'flex',
    justifyContent: 'center',
    margin: '24px 12px 12px',
    padding: '8px 10px',
    backgroundColor: '#333333',
    border: '1px solid #e05d5d',
    borderRadius: 4,
  },
  logoutButtonLabel: {
    color: '#e05d5d',
    fontSize: 14,
  },
}

export default styles
